module.exports = __webpack_public_path__ + "img/gi_mobilgurun.4096345d.png";